'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FontIcon = require('./FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FontIcon2.default;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/FontIcon/index.js
 ** module id = 561
 ** module chunks = 2
 **/